import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { ServiceCenterAPI } from "../../services";
import UserContext from "../../../../contexts/UserContext";

/**
 * Select de atendentes disponíveis
 */
const AttendantSelect = ({
  value,
  onChange,
  label,
  placeholder = "Selecione um atendente...",
  excludeCurrentUser = false,
  isDisabled = false,
  isClearable = true,
  className = "",
}) => {
  const { user: currentUser } = useContext(UserContext);
  const [attendants, setAttendants] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadAttendants = async () => {
      setIsLoading(true);
      try {
        const response = await ServiceCenterAPI.getAttendants();
        let list = response.results || response || [];

        // Excluir usuário atual se solicitado
        if (excludeCurrentUser && currentUser?.id) {
          list = list.filter((att) => att.id !== currentUser.id);
        }

        setAttendants(list);
      } catch (error) {
        console.error("Erro ao carregar atendentes:", error);
        setAttendants([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadAttendants();
  }, [excludeCurrentUser, currentUser?.id]);

  const options = attendants.map((att) => ({
    value: att.id,
    label: `${att.first_name} ${att.last_name || ""}`.trim(),
    email: att.email,
    department: att.department_name,
  }));

  // Suporta tanto value direto (número) quanto objeto {value, label}
  const selectedOption = options.find((opt) =>
    opt.value === value || opt.value === value?.value
  ) || null;

  const formatOptionLabel = (option) => (
    <div className="sc-attendant-option">
      <div className="sc-attendant-option__name">{option.label}</div>
      {option.department && (
        <div className="sc-attendant-option__department">
          🏢 {option.department}
        </div>
      )}
    </div>
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: "10px 12px",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "42px",
    }),
  };

  return (
    <div className={`sc-attendant-select ${className}`}>
      {label && <label className="sc-attendant-select__label">{label}</label>}
      <Select
        value={selectedOption}
        onChange={(option) => onChange(option || null)}
        options={options}
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
        noOptionsMessage={() => "Nenhum atendente encontrado"}
        loadingMessage={() => "Carregando..."}
      />
    </div>
  );
};

export default AttendantSelect;
